
/**
 * @desc 语言locale转换为小写和中划线
 * @param {String} lang 输入语言
 */
export function langTransform(lang: string): string {
  if (!lang) return lang
  const reg = new RegExp('([a-zA-Z]{2})[_-]?([A-Za-z]+)', 'g')
  return lang.replace(reg, '$1-$2')
}
